/* tslint:disable */
/* eslint-disable */
/**
 * Limber Admin API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ProgramDataDownload
 */
export interface ProgramDataDownload {
    /**
     * 
     * @type {string}
     * @memberof ProgramDataDownload
     */
    url: string;
}

export function ProgramDataDownloadFromJSON(json: any): ProgramDataDownload {
    return ProgramDataDownloadFromJSONTyped(json, false);
}

export function ProgramDataDownloadFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProgramDataDownload {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'url': json['url'],
    };
}

export function ProgramDataDownloadToJSON(value?: ProgramDataDownload | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'url': value.url,
    };
}


